import { documentService } from '@/services/api/document.service';
import { documentModel } from '@/models/api/document.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const DOCUMENT_MODULE = 'api/document';
export const GET_ALL_DOCUMENT = 'getAllDocument';
export const CREATE_DOCUMENT = 'createDocument';
export const GET_DOCUMENT = 'getDocument';
export const UPDATE_DOCUMENT = 'updateDocument';
export const DELETE_DOCUMENT = 'deleteDocument';

export const state = {
    list: {
        data: [],
        pagination: { pageNumber: 1, pageSize: 15, lastPage: 1, tableRowsCounts: 0, total: 0 },
    },
    details: {},
    status: { list: true, detail: true, save: true },
};

export const actions = {
    async [GET_ALL_DOCUMENT]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await documentService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({
                message: sharedHelper.getErrorMessage(error),
                title: i18n.t('message.error'),
            });
            return null;
        }
    },
    async [CREATE_DOCUMENT]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.document')]) });
            await dispatch(GET_ALL_DOCUMENT, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [GET_DOCUMENT]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await documentService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [UPDATE_DOCUMENT]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.document')]) });
            await dispatch(GET_ALL_DOCUMENT, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [DELETE_DOCUMENT]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await documentService.softDelete(uuid);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.document')]) });
            await dispatch(GET_ALL_DOCUMENT, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(documentModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data?.document || result?.data || result?.document || result || {};
        state.details = documentModel(payload);
        state.status.detail = true;
    },
    failure(state) {
        state.status = { list: true, detail: true, save: true };
    },
    success(state) {
        state.status = { list: true, detail: true, save: true };
    },
};
